const state = {
    languages: [],
    language: 'en-US',
    loadingSites: false,
    sites: [],
};

export default state;
